<template>
  <a-card :bordered="false">
    <CustomCrumbs :data-list="crumbsList" show-name="title"></CustomCrumbs>
    <div style="height: 20px"></div>
    <search-page-view
      ref="pageList"
      :columns="getProductColumns()"
      :queryParams="queryParams"
      row-key="productId"
      :leftSpace="10"
      :enable-search="false"
      :requestPromise="getProductList"
    >
      <a-button slot="operation" type="primary" style="margin-left: 20px;margin-bottom: 20px" @click="addEvent">+ 新建
      </a-button>
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditEvent(rowItem.record)">编辑</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import smartMixins from '../smartMixins'
import CustomCrumbs from '../../../../../customComponents/CustomCrumbs'
import store from '@/store'

export default {
  name: 'VmProductManager',
  mixins: [smartMixins],
  components: { CustomCrumbs },
  data() {
    return {
      crumbsList: [
        {
          title: '无人售货机(客房版)'
        },
        {
          title: '商品管理'
        }
      ]
    }
  },
  created() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    this.queryParams = {
      platformId: this.platformId,
      merchantId: this.merchantId
    }
  },
  mounted() {
  },
  activated() {
    this.$refs.pageList.refresh(true)
  },
  methods: {
    addEvent() {
      let pageParams = this.getPageParams()
      this.openNewPage('VmProductEditor', { ...pageParams })
    },
    toEditEvent(record) {
      let pageParams = this.getPageParams()
      this.openNewPage('VmProductEditor', { productId: record.productId, ...pageParams })
    },
    getProductList(params) {
      return this.getHttpServices().getServerApiService().post('/iot/vem/searchVemProductList', params)
    },
    getProductColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId',
          width: '80px'
        },
        {
          title: '商品标题',
          dataIndex: 'productName'
        },
        {
          title: '仓号',
          dataIndex: 'productSeat',
          width: '40px'
        },
        {
          title: '售价',
          dataIndex: 'salePrice',
          width: '100px'
        },
        {
          title: '累计售出',
          dataIndex: 'productSales',
          width: '100px'
        },
        {
          title: '当前库存',
          dataIndex: 'productStock',
          width: '100px'
        },
        {
          title: '创建时间',
          width: '160px',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          width: '76px',
          dataIndex: 'productStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style scoped>
</style>